
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"14","opacity":".6","stroke":"#7d7d7d","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.333 3.333a2.333 2.333 0 11-4.667 0 2.333 2.333 0 014.667 0zM14.667 10.667a2.333 2.333 0 11-4.667 0 2.333 2.333 0 014.667 0zM6 10.667a2.333 2.333 0 11-4.667 0 2.333 2.333 0 014.667 0z","stroke-width":"1.5"}})])
          )
        }
      }
    